
<button type="button" class="btn btn-info col-12 bordure-de-template mt-1" (click)="openModal()" >
    <h5 class="col-12 text-center pb-0 mb-0 " style="color:black;"> Tâches </h5>
    <div class="text-center">

        <img id="test" class=" text-center pb-0 mb-2 mt-3" src="assets/image/point.png" alt="imageParametrage">
    </div>
  </button>
<!--<app-task [info] = sendInfo() [display] = "display"></app-task>-->
<!--<button type="button" class="btn btn-primary" style="text-align:center" (click)="openModal(template)">modal</button>-->
<ng-template #template>
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Tache n° {{increment+1}}</h4>
      </div>
      <div class="modal-body" >
          <h5>Consigne : </h5>
          <p>{{tab[ordre[increment]].consigne}}</p>
          <input type="text" placeholder="Code..." id="code" value=""><button type="button" class="btn btn-outline-success pull-right" aria-label="Close" (click)="next()">Suivant</button>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger" aria-label="Close" (click)="modalRef.hide()">Fermer</button>
         
        </div>
    </div>
  </ng-template>


  <ng-template #debut>
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Formulaire de consentement éclairé et consignes générales</h4>
      </div>
      <div class="modal-body" >
          <p>{{instruction[instruc].p1}}</p><br>
          <p>{{instruction[instruc].p2}}</p><br>
          <p>{{instruction[instruc].p3}}</p><br>
          <input *ngIf="instruc==2" type="text" placeholder="Code participant" id="codeUser" value=""><button *ngIf="instruc!=4"type="button" class="btn btn-outline-success pull-right" (click)="next()">Suivant</button><button *ngIf="instruc==4"type="button" class="btn btn-outline-success pull-right" (click)="next()">Commencer l'experience !</button>
      </div>
    </div>
  </ng-template>

  <ng-template #fin>
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">C'est fini !!!</h4>
      </div>
      <div class="modal-body" >
        <p>Merci d'avoir participé.</p>
        <p>Nous vous souhaiterions que vous participiez à un questionnaire, en précisant votre code utilisateur.</p>
        <p>Pour rappel votre code utilisateur est : {{codeUser}}</p>
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSfoRz-ugk8BvqhyzwpXRz2VmgKoBmpS30o0ua-vSc8k6c2NyQ/viewform?usp=sf_link">Lien questionnaire</a>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger" aria-label="Close" (click)="modalRef.hide()">Fermer</button>
        </div>
    </div>
  </ng-template>
